import React, { useEffect } from "react";
import module from "./Lp.module.css";
import styles from "../components/layout/utils.module.css";
import {
  Alert,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Modal,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ExpandCircleDownSharpIcon from "@mui/icons-material/ExpandCircleDownSharp";
import { useNavigate } from "react-router-dom";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import Footer from "../components/atomic/organisms/Footer";
import WhatsItem from "../components/lp/WhatsItem";
import LpModal from "../components/lp/LpModal";

const WhatsItem01 = {
  imgPath: "healthy_img.png",
  textPath: "healthy_text.png",
  title: (
    <>
      販売実績7,000万食の
      <br />
      糖質・塩分に配慮した健康的な食事
    </>
  ),
  description:
    "ナッシュとは60品目以上の健康的なメニューの中から、好きなメニューだけを選んでお届け。苦手なものを食べなくて良いので、ヘルシーな食生活を実現できます。",
};

const WhatsItem02 = {
  imgPath: "easy_img.png",
  textPath: "easy_text.png",
  title: (
    <>
      自宅にお届けするので
      <br />
      買物・調理・片付も全部不要
    </>
  ),
  description:
    "必要な時に冷凍庫から食事を取り出し、電子レンジで温めるだけ。環境に優しい紙素材容器なので、ゴミ分別も不要です。",
};

const WhatsItem03 = {
  imgPath: "continuation_img.png",
  textPath: "continuation_text.png",
  title: (
    <>
      最安462円<span className={styles.f14}>（税込499円）</span>で購入できて
      <br />
      お財布にも優しい
    </>
  ),
  description:
    "ナッシュは、IT・企画・販売・製造・物流・配送まで、一社完結のビジネスモデルを採用しているため、他社類似サービスでは提供できない価格帯で商品をお届けします。",
};

const Lp = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [stopModalOpen, setStopModalOpen] = React.useState(false);
  const theme = useTheme();
  const isPc = useMediaQuery(theme.breakpoints.up("md"));
  const isSp = useMediaQuery(theme.breakpoints.up("sm"));
  const pcBr = isPc ? <br /> : null;
  const dir = isPc ? "pc" : "sp";
  const path = (name) =>
    `${process.env.PUBLIC_URL + "/lp/" + dir + "/" + name}`;
  const bothSizePath = (name) =>
    `${process.env.PUBLIC_URL + "/lp/both/" + name}`;

  const handleLoginPage = () => {
    // navigate("/signup");
    handleStopModal.open();
  };

  const handleModalOpen = () => {
    setOpen(true);
  };
  const handleModalClose = () => {
    setOpen(false);
  };

  const handleStopModal = {
    open: () => {
      setStopModalOpen(true);
    },
    close: () => {
      setStopModalOpen(false);
    },
  };

  const FooterIconButton = ({ url, pathName }) => (
    <Button
      sx={{ width: "32px", padding: "4px", minWidth: "inherit" }}
      href={url}
    >
      <img src={bothSizePath(pathName)} />
    </Button>
  );

  const GridItem = ({ children }) => (
    <Grid
      item
      xs={12}
      md={4}
      sx={{
        "@media (max-width: 900px)": {
          padding: "0px",
        },
      }}
    >
      {children}
    </Grid>
  );

  return (
    <div>
      <div className={module.wrapTop}>
        <Alert
          variant="filled"
          severity="warning"
          sx={{
            margin: "16px auto",
            width: "80%",
            maxWidth: "340px",
            position: "absolute",
            top: "0px",
            left: "0",
            right: "0",
            zIndex: 1000,
            fontWeight: "bold",
          }}
        >
          現在、新規の受付は終了しております。
        </Alert>
        <img className={module.topImg} src={path("top.png")} />
        <div className={module.wrapInner}>
          <img
            className={module.topTxtImg01}
            src={bothSizePath("top_text01.png")}
          />

          <div className={module.topBox}>
            <div className={module.presentBox}>
              <img
                className={module.presentTxtImg}
                src={bothSizePath("present_text.png")}
              />
              <img
                className={module.bubbleTxtImg}
                src={path("bubble_text.png")}
              />
            </div>
          </div>

          <p className={`${module.topTxt} ${styles.fontBold}`}>
            ナッシュアンバサダープログラムとは、
            <br />
            あなたのお友達やお知り合いに、ナッシュの商品やサービスを{pcBr}
            紹介することで、だれでも簡単にお小遣い稼ぎができる仕組みです。
          </p>
        </div>
      </div>
      <div className={module.contents}>
        <Button
          className={module.top_present_button}
          onClick={handleLoginPage}
          sx={{
            color: "white",
            backgroundColor: "#0900b2",
            borderRadius: "48px",
            border: "2px solid white",
            fontSize: "1.2rem",
            fontWeight: "bold",
            padding: "20px",
            width: "350px",
            "&:hover": {
              backgroundColor: "blue",
              cursor: "pointer",
            },
            "@media (max-width: 640px)": {
              width: "340px",
              padding: "12px",
            },
          }}
          endIcon={<ExpandCircleDownSharpIcon className={module.arrow_icon} />}
        >
          <span>新規募集は現在停止中です</span>
        </Button>
        <div className={module.labelStep}>
          <span className={module.leftBorder}></span>
          <p className={`${styles.fontBold} ${styles.f38}`}>
            <span className={`${styles.roboto} ${styles.f40} ${styles.cGreen}`}>
              3,000円
            </span>
            GETまでのカンタン
            <span className={`${styles.roboto} ${styles.f40} ${styles.cGreen}`}>
              3STEP
            </span>
          </p>
          <span className={module.rightBorder}></span>
        </div>
        <Grid
          container
          spacing={isPc ? 4 : 0}
          className={module.step}
          sx={{
            "@media (max-width: 900px)": {
              margin: "16px auto",
              width: "80%",
            },
            "@media (max-width: 640px)": {
              width: "100%",
            },
          }}
        >
          <GridItem item>
            <div className={module.stepItem}>
              <div className={module.stepTitle}>
                <img
                  className={module.stepCircle}
                  src={bothSizePath("step_circle01.png")}
                />

                <p
                  className={`${styles.fontBold} ${styles.cWhite} ${styles.textLeft}`}
                >
                  ナッシュアンバサダー{pcBr}プログラムに無料会員登録。
                </p>
              </div>

              <img
                className={module.stepIcon01}
                src={bothSizePath("step_1_icon.png")}
              />
            </div>
            <div className={module.inner_step}>
              <div className={`${styles.fontBold} ${styles.f16}`}>
                アンバサダープログラムに
                <br />
                アカウント無料登録。
              </div>
            </div>
          </GridItem>
          <GridItem item>
            <div className={module.stepItem}>
              <div className={module.stepTitle}>
                <img
                  className={module.stepCircle}
                  src={bothSizePath("step_circle02.png")}
                />

                <p
                  className={`${styles.fontBold} ${styles.cWhite} ${styles.textLeft}`}
                >
                  紹介はカンタン！
                  <br />
                  SNSでURLを投稿するだけ。
                </p>
              </div>

              <img
                className={module.stepIcon02}
                src={bothSizePath("step_2_icon.png")}
              />
            </div>
            <div className={module.inner_step}>
              <div className={`${styles.fontBold} ${styles.f16}`}>
                ナッシュをご紹介いただき、
                <br />
                新規利用者が専用ページ経由で購入、
                <br />
                配送完了でOK。
              </div>
            </div>
          </GridItem>
          <GridItem item>
            <div className={module.stepItem}>
              <div className={module.stepTitle}>
                <img
                  className={module.stepCircle}
                  src={bothSizePath("step_circle03.png")}
                />

                <p
                  className={`${styles.fontBold} ${styles.cWhite} ${styles.textLeft}`}
                >
                  1名紹介するたびに、口座に3,000円お振込！
                </p>
              </div>

              <img
                className={module.stepIcon03}
                src={bothSizePath("step_3_icon.png")}
              />
            </div>
            <div className={module.inner_step}>
              <div className={`${styles.fontBold} ${styles.f16}`}>
                銀行口座情報を登録したら、
                <br />
                1名紹介毎に3,000円お支払い！
              </div>
            </div>
            <div className={module.step_button}>
              <Button
                className={module.step_text}
                endIcon={
                  <ExpandCircleDownSharpIcon className={module.arrow_icon} />
                }
                sx={{ color: "blue", padding: "0px", fontWeight: "500" }}
                onClick={handleModalOpen}
              >
                お振込条件を確認する
              </Button>
            </div>
          </GridItem>
        </Grid>
      </div>

      <div className={module.whats}>
        <img
          className={module.whatsTitleTxt}
          src={bothSizePath("whats_nosh_text.png")}
        />

        <p
          className={`${module.whatsTopTxt} ${styles.yugo} ${styles.fontBold}`}
        >
          健康的な食生活を手軽に続けられるために
          <br />
          開発された食事をお届けします。
        </p>

        <div className={module.whatsBox}>
          <WhatsItem
            imgPath={WhatsItem01.imgPath}
            textPath={WhatsItem01.textPath}
            title={WhatsItem01.title}
            description={WhatsItem01.description}
          />
          <WhatsItem
            imgPath={WhatsItem02.imgPath}
            textPath={WhatsItem02.textPath}
            title={WhatsItem02.title}
            description={WhatsItem02.description}
          />
          <WhatsItem
            imgPath={WhatsItem03.imgPath}
            textPath={WhatsItem03.textPath}
            title={WhatsItem03.title}
            description={WhatsItem03.description}
          />
        </div>
      </div>

      <div className={module.wrapBottomPresent}>
        <img src={path("banner_bg.png")} />

        <p
          className={`${module.bannerTitle} ${styles.fontBold} ${styles.f40} ${styles.cWhite}`}
        >
          さあ、現金3,000円をGETしよう！
        </p>

        <Button
          sx={{
            position: "absolute",
            margin: "auto",
            left: "0px",
            right: "0px",
            color: "white",
            backgroundColor: "#0900b2",
            borderRadius: "48px",
            border: "2px solid white",
            fontSize: "1.2rem",
            padding: "20px",
            fontWeight: "bold",
            top: "50%",
            width: "340px",
            "@media (max-width: 900px)": {
              borderRadius: "36px",
              fontSize: "1.0rem",
              padding: "12px",
            },
            "&:hover": {
              backgroundColor: "blue",
              cursor: "pointer",
            },
            "@media (max-width: 640px)": {
              width: "280px",
              padding: "12px",
            },
          }}
          onClick={handleLoginPage}
          endIcon={<ExpandCircleDownSharpIcon className={module.arrow_icon} />}
        >
          <span>新規募集は現在停止中です</span>
        </Button>
      </div>
      <LpModal open={open} handleModalClose={handleModalClose}>
        <Typography
          id="modal-title"
          variant="h6"
          component="h2"
          fontWeight="bold"
          sx={{
            fontSize: "1.5rem",
            "@media (max-width: 456px)": {
              fontSize: "1.1rem",
            },
          }}
        >
          ナッシュ アンバサダーお支払サイクル
        </Typography>

        <p className={`${module.modalTxt} ${styles.f16} ${styles.fontMedium}`}>
          報酬のお支払いは、毎月月末に締めを行い、{isSp ? <br /> : null}
          翌月末に、ご登録頂いたご指定の銀行口座へお支払いさせて頂きます。
        </p>

        <div className={`${module.middleTxt} ${styles.fontBold}`}>
          例：3月10日に報酬が発生した場合
        </div>

        <div>
          <img
            src={bothSizePath("modal_graph.png")}
            className={module.modalImage}
          />
        </div>
      </LpModal>
      <LpModal open={stopModalOpen} handleModalClose={handleStopModal.close}>
        <Typography
          id="modal-title"
          variant="h6"
          component="h2"
          fontWeight="bold"
          sx={{
            fontSize: "1.5rem",
            "@media (max-width: 456px)": {
              fontSize: "1.1rem",
            },
          }}
        >
          新規アンバサダー受付停止中のご案内
        </Typography>
        <p className={`${module.modalTxt} ${styles.f16} ${styles.fontBold}`}>
          いつもナッシュをご利用いただきまして誠にありがとうございます。
        </p>
        <p className={`${module.modalTxt} ${styles.f16} ${styles.fontMedium}`}>
          現在ナッシュアンバサダーは大変好評につき、
          <br />
          さらなる改善と効率化のためシステムを改修中でございます。
          <br />
          募集再開の目処が立ち次第、こちらのサイトでお知らせいたします。
          <br />
          どうぞご期待ください。
        </p>
        <div className={module.modalImgText}>
          <img src={bothSizePath("modal_bottom.png")} />
        </div>
      </LpModal>
    </div>
  );
};

export default Lp;
